import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from '@algoan/deep-dive/button';
import { ComponentProps } from '@algoan/deep-dive/model';
import { defineMessages, useIntl } from 'react-intl';
import { Error } from '@algoan/deep-dive/error';
import { H2 } from '@algoan/deep-dive/fonts';

export interface UnauthorizedProps extends ComponentProps {
  /** Name used in the title */
  applicationName: string;
  /** Action to run when the button is pressed */
  onButtonClick: () => void;
}

export const unauthorizedMessages = defineMessages({
  message: {
    id: 'unauthorized_page.message',
    defaultMessage: 'Sorry,\u000ayou don’t have access\u000ato ',
    description: 'Main message on the page',
  },
  button: {
    id: 'unauthorized_page.button',
    defaultMessage: 'Log out',
    description: 'Title of the logout button',
  },
});

export const Unauthorized: FC<UnauthorizedProps> = ({
  applicationName,
  onButtonClick,
  className,
  'data-testid': dataTestId,
}) => {
  const intl = useIntl();

  return (
    <Error
      className={className}
      data-testid={dataTestId}
      buttons={
        <S.Button variant="main" onClick={onButtonClick}>
          {intl.formatMessage(unauthorizedMessages.button)}
        </S.Button>
      }
      title={
        <>
          <S.Text>{intl.formatMessage(unauthorizedMessages.message)}</S.Text>
          <S.BlueText>{applicationName}</S.BlueText>
        </>
      }
    />
  );
};

const S = {
  Text: styled(H2)`
    display: inline;
    white-space: pre-wrap;
  `,
  BlueText: styled(H2)`
    color: ${({ theme }) => theme.bluePeps};
    display: inline;
  `,
  Button: styled(Button)`
    width: 168px;
    height: 54px;
  `,
};
